<template>
  <v-container
    id="snackbar"
    fluid
    tag="section"
  >
    <!-- <base-material-snackbar
      v-model="show"
      type="error"

      absolute
      centered
      :color="color"
      :timeout="timeout"
      multi-line
      @click.native="show = false"
    >
      {{ message }}
    </base-material-snackbar> -->

    <v-snackbar
      v-model="show"
      type="error"
      elevation="24"

      centered
      :color="color"
      :timeout="timeout"
      multi-line
      style="z-index:99999"
    >
      <template v-slot:action="{ attrs }">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          :color="color"
          v-bind="attrs"
          @click.native="closeSnack"
        >
          <v-icon dark>
            mdi-close
          </v-icon>
        </v-btn>
      </template>
      <v-row>
        <v-col cols="auto">
          <v-icon>
            mdi-alert
          </v-icon>
        </v-col>
        <v-col>
          <p
            v-html="message"
          />
        </v-col>
      </v-row>
    </v-snackbar>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        show: false,
        top: true,
        message: '',
        color: '#c54747d4',
        timeout: -1,
      }
    },
    created: function () {
      this.$store.watch(
        state => state.snack,
        () => {
          console.log('watch snack')
          if (!this.$store.state.snack) {
            return
          }
          const message = this.$store.state.snack.message
          if (message) {
            this.show = true
            this.message = message
            if (this.$store.state.snack.timeout) {
              this.timeout = this.$store.state.snack.timeout
            }
            this.color = this.$store.state.snack.color
            this.$store.commit('setSnack', {})
          }
        },
      )
    },
    methods: {
      closeSnack (e) {
        e.preventDefault()
        this.show = false
      },
    },
  }
</script>
<style scoped>
#snackbar {
  display:contents !important;
  font-size: 1rem !important;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: 0.03125em !important;
    font-family: "Roboto", sans-serif !important;
}
</style>
